import React, { useState, useEffect, useCallback } from 'react';
import { connect } from 'react-redux';
import { Button, Container, Title, View } from '@common/components';
import { Row, Col, Layout } from 'antd';
import { Helmet } from 'react-helmet';
import { fetchModulesBySubmoduleCode } from '@resources/Module/actions';
import {
	fetchRentals,
	fetchRentalsByOrganizationModule,
	clearRentals,
} from '@resources/Rental/actions';
import { FormattedMessage, useIntl } from 'react-intl';
import { moduleByParam } from '@common/utils/module';
import { RentalItem } from '@fragments/items';
import CreateModal from './Create';
import UpdateModal from './Update';

const { Content } = Layout;

const Rental = (props) => {
	const {
		rentals,
		fetchRentals,
		fetchRentalsByOrganizationModule,
		fetchModulesBySubmoduleCode,
		clearRentals,
		match,
		organization,
	} = props;
	const intl = useIntl();

	const [create, setCreate] = useState(false);
	const [update, setUpdate] = useState(false);
	const [module, setModule] = useState({});

	useEffect(() => {
		const func = async () => {
			const { data } = await fetchModulesBySubmoduleCode('rental');
			await clearRentals();
			const param = match?.params || {};
			const modByParam = moduleByParam(data?.data, param);

			setModule(modByParam);

			organization?._id && modByParam
				? await fetchRentalsByOrganizationModule(
						organization?._id,
						modByParam && modByParam._id,
						param[`moduleId`]
				  )
				: await fetchRentals();
		};

		func();
	}, [
		fetchRentals,
		fetchModulesBySubmoduleCode,
		fetchRentalsByOrganizationModule,
		clearRentals,
		organization,
	]);

	const parseDataSource = useCallback(() => {
		return rentals.map((rental) => {
			return {
				key: rental._id,
				...rental,
			};
		});
	}, [rentals]);

	return (
		<Content>
			<Helmet>
				<title>
					{intl.formatMessage({
						id: 'common.rental.management',
						defaultMessage: 'Rental Management',
					})}
				</title>
			</Helmet>

			<CreateModal
				{...props}
				module={module}
				visible={create}
				onCancel={() => setCreate(false)}
			/>
			<UpdateModal
				{...props}
				module={module}
				visible={update}
				onCancel={() => setUpdate(false)}
			/>
			<View>
				<Container>
					<Row
						type="flex"
						justify="center"
						align="middle"
						className="mt-5">
						<Col md={{ span: 12 }}>
							<Title>
								<FormattedMessage
									id="common.rental"
									defaultMessage="Rental"
								/>
							</Title>
						</Col>
						<Col md={{ span: 12 }} className="text-right">
							<Button
								type="primary"
								onClick={() => setCreate(true)}>
								<FormattedMessage
									id="common.new.rentalItem"
									defaultMessage="New Rental Item"
								/>
							</Button>
						</Col>
					</Row>
					<Row type="flex" gutter={16}>
						{parseDataSource() &&
							parseDataSource().map((rental, index) => (
								<Col
									xs={24}
									sm={12}
									md={12}
									lg={8}
									key={`empty-post-${index}`}
									className="mt-4">
									<RentalItem
										rental={rental}
										onEdit={() => setUpdate(rental._id)}
									/>
								</Col>
							))}
					</Row>
				</Container>
			</View>
		</Content>
	);
};

const mapStateToProps = ({
	rentals,
	modules,
	event,
	facility,
	cellGroup,
	ministry,
	organization,
	mission,
	service,
}) => {
	return {
		rentals,
		modules,
		event,
		facility,
		cellGroup,
		ministry,
		organization,
		mission,
		service,
	};
};

export default connect(mapStateToProps, {
	fetchRentals,
	fetchRentalsByOrganizationModule,
	fetchModulesBySubmoduleCode,
	clearRentals,
})(Rental);
